// 9fbef606107a605d69c0edbcd8029e5d
import { PropTypes, string, bool, shape, number } from 'prop-types';
import React from 'react';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import useInfluencerBadge from '../../../../../hooks/useInfluencerBadge';
import withStyles from '../../../hoc/withStyles';
import BodyCopy from '../../BodyCopy';
import style, { StyledInfluencerBadgeContainer } from '../styles/InfluencerBadgeHandle.style';

const InfluencerBadgeHandle = ({
  className,
  image,
  influencerTags,
  isAbOn,
  index,
  isFavoriteView,
}) => {
  const handle = useInfluencerBadge(influencerTags, index, image, isAbOn);
  if (handle?.length === 0) return '';
  return (
    <StyledInfluencerBadgeContainer isFavoriteView={isFavoriteView}>
      <BodyCopy fontSize="fs12" className={`${className} handlesContainer`} fontFamily="secondary">
        {handle?.map((handleName) => {
          return <div key={handleName}>{handleName}</div>;
        })}
      </BodyCopy>
    </StyledInfluencerBadgeContainer>
  );
};

InfluencerBadgeHandle.propTypes = {
  className: PropTypes.string.isRequired,
  image: string,
  isAbOn: bool,
  influencerTags: shape([]),
  index: number,
  isFavoriteView: bool,
};
InfluencerBadgeHandle.defaultProps = {
  image: '',
  isAbOn: false,
  influencerTags: [],
  index: 0,
  isFavoriteView: false,
};

export default errorBoundary(withStyles(InfluencerBadgeHandle, style));
export { InfluencerBadgeHandle as InfluencerBadgeHandleVanilla };
